import { atom  } from "recoil";

export const matchDataState = atom({
    key : "matchDataState",
    default : []
})